import React, { useEffect, useState } from 'react';
import ShowOperatorUnitMigrationHistory from '../../Components/ShowOperatorUnitMigrationHistory';
import ModalWarn from '../../Components/Modal/Warn/index'

export default function RegionalManagerMigrationHistory(props) {
    const [ regionalManager, setRegionalManager ] = useState({
        cpf: '',
        name: '',
        organ: {value: '', label: ''},
        unidade: {value: '', label: ''},
        dt_inc: '',
        dt_canc_exp: ''
    });
    const [ unitMigrationHistory, setUnitMigrationHistory ] = useState([]);
    const [ loadRegionalManager, setLoadRegionalManager ] = useState(false);
    const [ pageOptions, setPageOptions ] = useState([]);
    const [ page, setPage ] = useState({
        label: "1", value: "1"
    });
    const [ totalFilter, setTotalFilter ] = useState("0");
    const [ rangePages, setRangePages ] = useState({
        label: "10", value: "10"
    });
    const [ erroMsg, setErroMsg ] = useState([]);
    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)

    useEffect(() => {
        async function loadRegionalManagerDetails() {
            const requestOptions = {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                    'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
                }),
                body: JSON.stringify({
                    cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",  //Neste caso, o cpf_atendente se refere ao gestor que está operando
                    id_usuario_orgao: props.location.state.result_search.ID_USUARIO_ORGAO,
                }),
            };
            await fetch(`${process.env.REACT_APP_API_URL}/gestao/detalhaGestorRegional`, requestOptions).then(function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        // CONSUMIU O BACKEND BALCAO COM SUCESSO !!!!
                        const organ={
                            value: data.CODIGO_ORGAO,
                            label: data.NOME_ORGAO
                        }
                        let unidades = [];
                        data.UNIDADES_VINCULADAS && data.UNIDADES_VINCULADAS.forEach((unidade) => {
                            unidades.push({
                                value: unidade.CODIGO_UNIDADE,
                                label: unidade.NOME_UNIDADE
                            })
                        })

                        setRegionalManager({
                            id_usuario_orgao: data.ID_USUARIO_ORGAO, 
                            cpf: props.location.state.result_search.CPF_USUARIO, 
                            name: props.location.state.result_search.NOME_USUARIO, 
                            organ: organ, 
                            dt_inc: data.DATA_INCLUSAO, 
                            dt_canc_exp: data.DATA_CANCELAMENTO,
                            unidades_vinculadas: unidades,
                        });
                    });
                } else if (response.status === 422) {
                    response.json().then(function(data) {
                        if (!!data.errorCode && !!data.message) {
                            // inserir a mensagem: data.message no aviso de erro
                            console.log(data.message);
                        } else {
                            // inserir mensagem genérica
                            console.log('Response error in gestao/detalhaGestorRegional BackendBalcao');
                        }
                    });
                } else if (response.status === 403) {
                    response.json().then(function (data) {
                      setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                      setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                      setModalInvalidSessionError(true)
                    })
                } else {
                    // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                    //setLoading(false);
                    //setModalError(true);
                    console.log('Request error in gestao/detalhaGestorRegional BackendBalcao');
                }
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
            });
        }

        async function loadUnitMigrationHistory() {
            const requestOptions = {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                    'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
                }),
                body: JSON.stringify({
                    cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",  //Neste caso, o cpf_atendente se refere ao gestor que está operando
                    id_usuario_orgao: props.location.state.result_search.ID_USUARIO_ORGAO,
                    pagina_atual: 1,
                    qtd_registros: 10
                }),
            };
            
            await fetch(`${process.env.REACT_APP_API_URL}/gestao/listaHistoricoMigracaoUnidades`, requestOptions).then(
                function(response) {
                if (response.ok) {
                    response.json().then(function(data) {
                        const maxPageOption = Math.ceil(Number(data.total) / Number(rangePages.value))
                        let list = []
                        let obj = {}
                        for(var i = 1; i <= maxPageOption; i++) {
                            obj = {
                                value: String(i),
                                label: String(i)
                            }

                            list.push(obj);
                        }

                        setPageOptions(list);
                        setPage({label: "1", value: "1"});
                        setUnitMigrationHistory(data.historicoMigracaoUnidades);
                        setTotalFilter(data.total);
                    });
                } else {
                    console.log('Error request to /gestao/listaHistoricoMigracaoUnidades');
                }
            }).catch(function(err) {
                console.error('Failed retrieving information', err);
            });
        }

        if (!loadRegionalManager && props.location.state !== undefined) {
            loadRegionalManagerDetails();
            loadUnitMigrationHistory();
            setLoadRegionalManager(true);
        }
    }, [props, regionalManager, loadRegionalManager, rangePages]);

    const onChangePaginationConfig = async (ranPag, pag, isRanPag) => {
        setErroMsg(undefined);

        const requestOptions = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",  //Neste caso, o cpf_atendente se refere ao gestor que está operando
                id_usuario_orgao: props.location.state.result_search.ID_USUARIO_ORGAO,
                pagina_atual: isRanPag ? "1" : pag.value,
                qtd_registros: ranPag.value
            }),
        };
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/listaHistoricoMigracaoUnidades`,
                    requestOptions
        ).then(function(response) {
            if (response.ok) {
                response.json().then(function(data) {
                    const maxPageOption = Math.ceil(Number(data.total) / Number(ranPag.value))
                    let list = []
                    let obj = {}
                    for(var i = 1; i <= maxPageOption; i++) {
                        obj = {
                            value: String(i),
                            label: String(i)
                        }

                        list.push(obj);
                    }

                    setPageOptions(list);
                    if(isRanPag){
                        setPage({label: "1", value: "1"});
                    }
                    setUnitMigrationHistory(data.historicoMigracaoUnidades);
                    setTotalFilter(data.total);
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        setErroMsg(data.message)
                    } else {
                        setErroMsg('Houve algum problema no servidor.');
                    }
                    //setLoading(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setModalInvalidSessionError(true)
                })
            } else {
                // FALHOU AO CONSUMIR O BACKEND DO BALCAO !!!!
                //setLoading(false);
                console.log('Request error in gestao/listaHistoricoMigracaoUnidades BackendBalcao');
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    };

    return (
        <>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />
            <ShowOperatorUnitMigrationHistory
                pageTitle='Histórico de migração do gestor regional'
                operator={regionalManager} 
                setOperator={setRegionalManager}
                loadOperator={loadRegionalManager}
                buttonBackRoute='/gerenciarGestoresRegionais'
                buttonEditRoute='/editarGestorRegional'
                history={props.history}
                tableResultListTitle='Lista das unidades anteriores do gestor regional'
                onChangePaginationConfig={onChangePaginationConfig}
                totalFilter={totalFilter}
                searchResult={unitMigrationHistory}
                pageOptions={pageOptions}
                setPage={setPage}
                page={page}
                erroMsg={erroMsg}
                rangePages={rangePages}
                setRangePages={setRangePages}
            />
        </>
    );
}